import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { dateTime } from "@gravity-ui/date-utils";
export var CountdownTimer = function (props) {
    // const startDate = dateTime({ input: props.date });
    var _a = useState(""), timeLeft = _a[0], setTimeLeft = _a[1];
    useEffect(function () {
        var targetDate = dateTime({ input: props.date }).toDate();
        targetDate.setMinutes(targetDate.getMinutes() + 15); // Добавляем 15 минут
        var timer = setInterval(function () {
            var now = new Date();
            var difference = +targetDate - +now;
            if (difference <= 0) {
                setTimeLeft("00:00");
                clearInterval(timer);
            }
            else {
                var minutes = Math.floor(difference / 1000 / 60);
                var seconds = Math.floor((difference / 1000) % 60);
                setTimeLeft("".concat(String(minutes).padStart(2, "0"), ":").concat(String(seconds).padStart(2, "0")));
            }
        }, 1000);
        // Очистка интервала при размонтировании
        return function () { return clearInterval(timer); };
    }, [props.date]);
    return (_jsxs("div", { children: [_jsx("h3", { children: "\u041E\u0441\u0442\u0430\u043B\u043E\u0441\u044C \u0432\u0440\u0435\u043C\u0435\u043D\u0438:" }), _jsx("p", { style: { fontSize: "2rem", fontWeight: "bold" }, children: timeLeft })] }));
};
